import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_up",
  "use": "icon_up-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_up\"><path d=\"M12.4696 29.2165C11.3367 30.7599 12.3819 33 14.2348 33H33.7652C35.6181 33 36.6633 30.7599 35.5304 29.2165L25.7652 15.9125C24.8722 14.6958 23.1278 14.6958 22.2348 15.9125L12.4696 29.2165Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol